import axios from "axios";
import { useEffect, useState } from "react";
import Header from "../../../components/Header";
import BangCauXD from "../../../components/BangCauXD"; 
import swal from "sweetalert";
import chen from "./../img/chen.png";
import dia from "./../img/dia.png";
import "./../xd.css";

function XD60s() {
    const SANH_ID = 6; 

    const [isVisible, setVisible] = useState(null);
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(null);
    const [historyGame, setHistoryGame] = useState(null);
    const [second, setSecond] = useState(60); // 60s
    const [minute, setMinute] = useState(1);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();
    const [total, setTotal] = useState(null);
    const [total2, setTotal2] = useState(null);
    const [setting, setSetting] = useState(null);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [newMoney, setNewMoney] = useState(null);
    const [message, setMessage] = useState(null);
    const [share, setShare] = useState(false);
    const [choose, setChoose] = useState([]);
    const [activeOption, setActiveOption] = useState(null);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    const handleOptionClick = (option) => {
        setActiveOption(option); 
        const currentMoney = newMoney ? Number(String(newMoney).replaceAll(".", "").replaceAll(",", "")) : 0;
        const addMoney = Number(option) * 1000;
        const totalMoney = currentMoney + addMoney;
        setNewMoney(totalMoney.toLocaleString("vi-VN"));
    };

    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = {
            "6": "Lẻ",
            "5": "Chẵn",
            "4": "3 Trắng, 1 Đỏ",
            "3": "3 Đỏ, 1 Trắng",
            "2": "4 Trắng",
            "1": "4 Đỏ"
        };
        return String(stateStr).trim().split(/\s+/).map(s => map[s] || s).join(", ");
    };

    const currentBetId = bet?.id_bet ? Number(bet.id_bet) : 0;
    const pastTotal = total ? total.filter(item => Number(item.id_bet) < currentBetId) : [];
    const lastFinishedSession = pastTotal.length > 0 ? pastTotal[0] : null;

    useEffect(() => {
        let pointEl = document.querySelector(".point");
        if(pointEl) pointEl.style.animation = "movePointBack 0.1s forwards";

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
        });
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if(res.data && res.data.data) setSetting(res.data.data[0]);
        });

        axios.get(`${process.env.REACT_APP_API_URL}/XD60s/get?sanh=${SANH_ID}`).then((res) => {
            if(res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if(data) {
                    setBet(data);
                    setDulieunhap(new Date(data.createdAt));
                    setStart(true);
                }
            }
        });
        
        axios.get(`${process.env.REACT_APP_API_URL}/XD60s/getallbet?sanh=${SANH_ID}`, {})
            .then((res) => {
                setTotal(res.data.data);
                setTotal2(res.data.data);
            })
            .catch(() => setTotal(null));
            
        getHistoryBet();
        getProfile();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(60 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
                    setProfile(res.data.data);
                });
                axios.get(`${process.env.REACT_APP_API_URL}/XD60s/get?sanh=${SANH_ID}`).then((res) => {
                    if(res.data && res.data.data) {
                        const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                        if(data) {
                            setBet(data);
                            setDulieunhap(new Date(data.createdAt));
                        }
                    }
                });
                axios
                    .get(`${process.env.REACT_APP_API_URL}/XD60s/getallbet?sanh=${SANH_ID}`, {})
                    .then((res) => {
                        setTotal(res.data.data);
                        setTotal2(res.data.data);
                    })
                    .catch(() => setTotal(null));
                getHistoryBet();
                getProfile();
            }
        }, 500);

        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);

        let myTimeout;

        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
            return () => clearTimeout(myTimeout);
        } else if (curTime_second < 60 && curTime_second >= 0) {
            setSecond(curTime_second);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
            return () => clearTimeout(myTimeout);
        } else {
            myTimeout = setTimeout(() => { setUpdate(update + 1); }, 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second);
            setMinute(Math.floor(curTime_second / 60));

            if (curTime_second > 60 || curTime_second <= 0) {
                setStart(false);
                setMinute(1);
                setSecond(0);
                return () => clearTimeout(myTimeout);
            }
            myTimeout = setTimeout(() => { setSecond(second - 1); }, 1000);
        }
        return () => clearTimeout(myTimeout);
    }, [second, start, dulieunhap]);

    function onChoose(num) {
        if (choose.includes(num)) {
            setChoose(choose.filter((item) => item !== num));
        } else {
            setChoose([...choose, num]);
        }
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (newMoney == 0 || newMoney == null) {
            swal("Thất bại", "Bạn chưa nhập tiền", "error");
            return;
        }
        const cleanMoney = Number(newMoney.replaceAll(".", "").replaceAll(",", ""));
        const formData = {
            result: choose.join(" "),
            id: bet?._id,
            money: choose.length * cleanMoney,
            sanh: SANH_ID 
        };
        if (profile && formData.money > profile.money) {
            swal("Thất bại", "Số dư không đủ", "error");
            return;
        }
        if (Number(second) <= 10 && Number(minute) == 0) {
            swal("Đã hết thời gian cược", "Vui lòng chờ phiên tiếp theo", "info");
            return;
        }
        if (choose.length == 0) {
            swal("Thất bại", "Bạn chưa lựa chọn", "error");
            return;
        }
        axios.post(`${process.env.REACT_APP_API_URL}/history/chooseXD60s`, formData).then((res) => {
            swal("Thành công", "Đặt cược thành công", "success");
            setChoose([]);
            setNewMoney("");
            setActiveOption(null);
            getHistoryBet();
            getProfile();
        }).catch((err) => swal("Đã xảy ra lỗi", "Vui lòng thử lại", "error"));
    };

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [activeTab, setActiveTab] = useState("tab1");
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        getHistoryBet();
    };

    function getHistoryBet() {
        axios.get(`${process.env.REACT_APP_API_URL}/history/historyus`, { params: { keyword: "XD60s", sanh: SANH_ID } })
            .then((res) => {
                if(res.data && res.data.data) setHistoryGame(res.data.data);
            })
            .catch((err) => function () {});
    }

    function getProfile() {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            if(res.data && res.data.data) setProfile(res.data.data);
        });
    }

    const [datcuoc, setDatcuoc] = useState(false);
    const [dungcuoc, setDungcuoc] = useState(false);
    const [trathuong, setTrathuong] = useState(false);

    useEffect(() => {
        if (bet) {
            let pointEl = document.querySelector(".point");
            let checkEl = document.querySelector(".check");
            if (Number(second) === 1) {
                if(pointEl) pointEl.style.animation = "movePoint 4s forwards";
                if(checkEl) checkEl.style.animation = "";
            } else if (Number(second) === 55) {
                if(pointEl) pointEl.style.animation = "movePointBack 4s forwards";
                getHistoryBet();
                getProfile();
                setDatcuoc(true);
                setTimeout(function () {
                    setDatcuoc(false);
                }, 3000);
            } else if (Number(second) === 10) {
                setDungcuoc(true);
                setTimeout(function () {
                    setDungcuoc(false);
                }, 3000);
            } else if (Number(second) === 0) {
                setTrathuong(true);
                setTimeout(function () {
                    setTrathuong(false);
                }, 3000);
            } else if (Number(second) === 45) {
                if(pointEl) pointEl.style.animation = "shake 4s forwards";
                if(checkEl) checkEl.style.animation = "shake1 4s forwards";
            } else if (Number(second) === 40) {
                if(checkEl) checkEl.style.animation = "";
            } 
        }
    }, [second, bet]);

    return (
        <>
            <div className="main xd">
                <Header profile={profile} />
                
                <div className="box-bg-game">
                    <div className="bg-game">
                        <div style={{ position: "absolute", top: "3px", left: "0", width: "100%", textAlign: "center", fontSize: "26px", fontWeight: "bold", color: "#FFD700", textTransform: "uppercase", zIndex: 10, pointerEvents: "none" }}>
                            Sảnh F
                        </div>

                        <div data-v-45adac70="" className="v_circle taste_lottery_countdown xodi v_circle_show v_circle_PC">
                            <div data-v-45adac70="" className="mask full">
                                {second >= 30 && <div data-v-45adac70="" className="fill fix_l" style={{ transform: `rotate(${180 - (60 - second) * 6}deg)` }}></div>}
                            </div>
                            <div data-v-45adac70="" className="mask half">
                                {second < 30 ? (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(${second * 6}deg)` }}></div>
                                ) : (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(180deg)` }}></div>
                                )}
                            </div>
                            <div data-v-45adac70="" flex="main:center cross:center" className="pv">
                                <span data-v-45adac70="" className="progress">
                                    {second}
                                </span>
                            </div>
                        </div>

                        <div className="boxdia">
                            <img alt="" src={chen} className="point" style={{ animation: "movePointBack" }} />
                            <img alt="" className="check" src={dia} />
                            
                            {lastFinishedSession && lastFinishedSession.result && (
                                <div className="history_xd result-dia">
                                    {lastFinishedSession.result.trim().split(" ").map((item, i) => (
                                        <div key={i} className={`a${item}`}></div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="timexd">
                            <span style={{ fontSize: "0.4rem" }}>Phiên {bet?.id_bet}</span> <br />
                            <span style={{ opacity: "0.7" }}>{bet ? formatDate(new Date(bet.createdAt)) : null}</span>
                        </div>
                        <div style={{ position: "absolute", bottom: "10px", width: "100%", display: "flex", justifyContent: "space-between", padding: "0 15px", boxSizing: "border-box", color: "#fff", fontSize: "14px", zIndex: 10 }}>
                            <div><span style={{ color: "#ffc107", fontWeight: "bold" }}>Cược:</span> {newMoney ? Number(newMoney.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN") : "0"}</div>
                        </div>

                        {dungcuoc && <div className="game-noti dungcuoc"><img src={require("./../img/noti-dungcuoc.png")} alt="dừng cược" /></div>}
                        {datcuoc && <div className="game-noti datcuoc"><img src={require("./../img/noti-datcuoc.png")} alt="đặt cược" /></div>}
                        {trathuong && <div className="game-noti trathuong"><img src={require("./../img/noti-trathuong.png")} alt="trả thưởng" /></div>}
                    </div>
                </div>

                <div className="bet-grid-4col">
                    <div className="bet-col">
                        <button className={`bet-btn ${choose.includes("2") ? "active" : ""}`} onClick={() => onChoose("2")}>
                            <div className="bet-badge bg-blue">2</div>
                            <div className="b-ratio">1 : {setting?.xd_4trang || 12}</div>
                            <div className="dice-row">
                                <span className="d-dot w"></span><span className="d-dot w"></span><span className="d-dot w"></span><span className="d-dot w"></span>
                            </div>
                        </button>
                        <button className={`bet-btn ${choose.includes("4") ? "active" : ""}`} onClick={() => onChoose("4")}>
                            <div className="bet-badge bg-red">4</div>
                            <div className="b-ratio">1 : {setting?.xd_3trang || 3.6}</div>
                            <div className="dice-row">
                                <span className="d-dot w"></span><span className="d-dot w"></span><span className="d-dot w"></span><span className="d-dot r"></span>
                            </div>
                        </button>
                    </div>

                    <div className="bet-col">
                        <button className={`bet-btn btn-tall ${choose.includes("5") ? "active" : ""}`} onClick={() => onChoose("5")}>
                            <div className="b-ratio">1 : {setting?.xd_chan || 1.96}</div>
                            <div className="b-text-chan">CHẴN</div>
                        </button>
                    </div>

                    <div className="bet-col">
                        <button className={`bet-btn btn-tall ${choose.includes("6") ? "active" : ""}`} onClick={() => onChoose("6")}>
                            <div className="b-ratio">1 : {setting?.xd_le || 1.96}</div>
                            <div className="b-text-le">LẺ</div>
                        </button>
                    </div>

                    <div className="bet-col">
                        <button className={`bet-btn ${choose.includes("1") ? "active" : ""}`} onClick={() => onChoose("1")}>
                            <div className="bet-badge bg-yellow">1</div>
                            <div className="b-ratio">1 : {setting?.xd_4do || 12}</div>
                            <div className="dice-row">
                                <span className="d-dot r"></span><span className="d-dot r"></span><span className="d-dot r"></span><span className="d-dot r"></span>
                            </div>
                        </button>
                        <button className={`bet-btn ${choose.includes("3") ? "active" : ""}`} onClick={() => onChoose("3")}>
                            <div className="bet-badge bg-green">3</div>
                            <div className="b-ratio">1 : {setting?.xd_3do || 3.6}</div>
                            <div className="dice-row">
                                <span className="d-dot r"></span><span className="d-dot r"></span><span className="d-dot r"></span><span className="d-dot w"></span>
                            </div>
                        </button>
                    </div>
                </div>

                <div className="bet_taste_chips">
                    {["5", "10", "50", "100", "500", "1000", "5000"].map((val, idx) => (
                        <div key={idx} data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === val ? "active" : ""}`} onClick={() => handleOptionClick(val)}>
                            <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip">
                                <div data-v-331b32c3="" className={`taste_chip_base taste_chip_${val === "5" ? "10" : val === "10" ? "25" : val === "50" ? "50" : val === "100" ? "100" : val === "500" ? "200" : val === "1000" ? "500" : "5"}`}>
                                    <div data-v-331b32c3="" className="item_chip_num">
                                        <span data-v-331b32c3="">{val}K</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="bet-input-panel bet_panel_taste">
                    <div data-v-331b32c3="" flex="main:justify box:justify cross:center" className="bet_taste_info">
                          <button
                            data-v-331b32c3=""
                            className="bet_taste_reset"
                            onClick={() => {
                                setActiveOption(null);
                                setNewMoney(""); 
                                setChoose([]);   
                            }}>
                            Đặt lại
                        </button>
                        <div data-v-331b32c3="" className="bet_taste_text">
                            <div data-v-331b32c3="" flex="main:center cross:center" className="bet_taste_num vi">
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Đã chọn
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__protrude">
                                    {choose ? choose.length : 0}
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Lô
                                </span>
                            </div>
                            <div data-v-331b32c3="" flex="cross:center" className="bet_taste_money">
                                <input
                                    data-v-331b32c3=""
                                    flex-box="8"
                                    className="bet_taste_money_bet"
                                    min={1000}
                                    value={newMoney || ""}
                                    onChange={(e) => setNewMoney(e.target.value)}
                                    onClick={() => setActiveOption(null)}
                                    onKeyUp={(e) => setNewMoney(Number(e.target.value.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN"))}
                                    name="money"
                                    type="text"
                                    placeholder="Nhập số tiền"
                                />
                            </div>
                        </div>
                        <button data-v-331b32c3="" className="bet_taste_submit" type="submit" onClick={onSubmit}>
                            Đặt cược
                        </button>
                    </div>
                </div>

                <div className="bangcau-wrapper" style={{ marginTop: "15px", marginBottom: "20px", marginLeft: "-0.32rem", marginRight: "-0.32rem" }}>
                    <BangCauXD dataHistory={pastTotal} />
                </div>

                <div className="history_game" style={{ marginLeft: "-0.32rem", marginRight: "-0.32rem" }}>
                    <ul className="tab-navigation">
                        <li className={activeTab === "tab1" ? "active" : ""} onClick={() => handleTabClick("tab1")}>
                            Lịch sử trò chơi
                        </li>
                        <li className={activeTab === "tab2" ? "active" : ""} onClick={() => handleTabClick("tab2")}>
                            Lịch sử của tôi
                        </li>
                    </ul>

                    <div className="tab-content">
                        {activeTab === "tab1" && (
                            <div className="award_tb">
                                <table>
                                    <thead style={{ textAlign: "center" }}>
                                        <tr>
                                            <td>Phiên</td>
                                            <td>Kết quả</td>
                                            <td>Thời gian</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{bet && bet.id_bet}</td>
                                            <td style={{ textAlign: "center", color: "#ed6c02" }}>Đang chờ kết quả</td>
                                            <td>{bet && formatDate(new Date(bet.createdAt))}</td>
                                        </tr>
                                        {pastTotal &&
                                            pastTotal.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "center" }}>{item?.id_bet}</td>
                                                    <td
                                                        className="history_xd"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        }}>
                                                        {item.result && item.result.split(" ").map((item, i) => (
                                                            <div key={i} className={`a${item}`}></div>
                                                        ))}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>{formatDate(new Date(item.createdAt))}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {activeTab === "tab2" && (
                            <>
                                {historyGame != null && historyGame.length > 0 ? (
                                    <div className="content-history award_tb">
                                        {historyGame?.filter(item => Number(item.sanh) === SANH_ID || item.sanh === `Xóc đĩa 60s (Sảnh F)` || item.sanh === `Sảnh F`).map((item, key) => {
                                            
                                            const itemBetId = Number(item?.id_bet?.id_bet || item?.id_bet || 0);
                                            const isFutureOrPending = itemBetId >= currentBetId;
                                            
                                            const displayStatusText = isFutureOrPending ? "Chờ xổ" : (item.status_bet === "Win" ? "Thắng" : "Thua");
                                            const statusClass = isFutureOrPending ? "pending" : (item.status_bet === "Win" ? "win" : "lose");

                                            return (
                                                <div
                                                    key={key}
                                                    className="item_inner"
                                                    style={{ padding: "5px" }}
                                                    onClick={() => {
                                                        setLs({ ...item, isFutureOrPending });
                                                        setShow(true);
                                                    }}>
                                                    <div className="item_history">
                                                        <div className="title_item_history" style={{ display: "flex", alignItems: "center" }}>
                                                            <span className="sanh" style={{ color: "#f5f5f5", fontWeight: "bold", fontSize: "15px" }}>
                                                                Sảnh F
                                                            </span>
                                                            <span className={`badge-status ${statusClass}`}>
                                                                {displayStatusText}
                                                            </span>
                                                        </div>
                                                        <div className="id_history_sanh">Phiên: {itemBetId}</div>
                                                        
                                                        <div className="id_history_sanh" style={{ color: "#ffc107", fontWeight: "bold" }}>
                                                            Chọn: {getBetLabel(item.state)}
                                                        </div>
                                                    </div>
                                                    <div className="money_history">
                                                        <span className="money" style={{ color: "#28a745", fontWeight: "bold" }}>
                                                            {Number(item.money).toLocaleString("vi-VN")} đ
                                                        </span>
                                                        <div className="time_choose">{formatDate(new Date(item.createdAt))}</div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                ) : (
                                    <div style={{ padding: "20px", textAlign: "center" }}>Chưa có lịch sử cược</div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                  {isShow === true && ls ? (
    <div className="modal" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999999
    }}>
        <div className="modaloverlay" 
            onClick={() => setShow(false)}
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                cursor: "pointer"
            }}
        >
            <i className="ti-close closelogin"></i>
        </div>

        <div className="modalbody" style={{
            position: "relative",
            zIndex: 10,
            backgroundColor: "#ffffff",
            color: "#0a0000",
            borderRadius: "8px",
            width: "90%",
            maxWidth: "350px",
            padding: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.5)"
        }}>
            <div>
                <div className="modalinner">
                    <div className="modalheader" style={{ paddingBottom: "15px", textAlign: "center", fontSize: "18px", fontWeight: "bold", borderBottom: "1px solid #333", marginBottom: "15px" }}>
                        Chi tiết cược
                    </div>
                    
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div>Trò chơi</div>
                        <div>Xóc đĩa 60s (Sảnh F)</div>
                    </div>
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div>Phiên</div>
                        <div>{ls?.id_bet?.id_bet || ls?.id_bet}</div>
                    </div>
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div>Thời gian</div>
                        <div>{formatDate(new Date(ls.createdAt))}</div>
                    </div>
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div>Đặt cược</div>
                        <div style={{ color: "#d32f2f", fontWeight: "bold" }}>{getBetLabel(ls.state)}</div>
                    </div>
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div>Tổng đặt</div>
                        <div>{Number(ls.money).toLocaleString("vi-VN")} đ</div>
                    </div>
                    <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                        <div>Tổng thắng</div>
                        <div style={{ color: "#28a745", fontWeight: "bold" }}>
                            {ls.isFutureOrPending ? "Đang chờ..." : `${Number(ls.moneythang || 0).toLocaleString("vi-VN")} đ`}
                        </div>
                    </div>
                    
                    {!ls.isFutureOrPending && ls.id_bet?.result && (
                        <>
                            <h3 style={{ fontSize: "14px", margin: "10px 0", textAlign: 'center' }}>
                                Kết quả phiên {ls?.id_bet?.id_bet || ls?.id_bet}
                            </h3>
                            <div className="history_xd" style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "5px", fontSize: "13px", marginBottom: "15px" }}>
                                {ls.id_bet.result.split(" ").map((item, i) => (
                                    <div key={i} className={`a${item}`}></div>
                                ))}
                            </div>
                        </>
                    )}

                    <div>
                        <div className="modalformcontrols">
                            <button
                                onClick={() => setShow(false)}
                                className="popup-close"
                                style={{
                                    background: "#0064ff",
                                    color: "#fff",
                                    border: "none",
                                    boxShadow: "none",
                                    textShadow: "none",
                                    width: "100%",
                                    marginTop: "5px",
                                    padding: "12px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                    cursor: "pointer"
                                }}>
                                ĐÓNG
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
) : null}

                <style>{`
                    .bet-grid-4col { 
                        display: grid; 
                        grid-template-columns: 1fr 0.8fr 0.8fr 1fr; 
                        gap: 6px; 
                        padding: 8px 4px; 
                        background: transparent; 
                        
                        /* Phá vỡ padding của thẻ main để tràn 2 bên */
                        margin-left: -0.32rem;
                        margin-right: -0.32rem;
                    }
                    .bet-col { 
                        display: grid; 
                        grid-template-rows: repeat(2, 1fr); 
                        gap: 6px; 
                    }
                    .bet-btn { 
                        position: relative; 
                        background: rgba(0, 140, 255, 0.2); 
                        border: 1px solid hsla(0, 0%, 100%, 0.41); 
                        border-radius: 6px; 
                        display: flex; 
                        flex-direction: column; 
                        align-items: center; 
                        justify-content: center; 
                        padding: 12px 2px 10px; 
                        cursor: pointer; 
                        transition: 0.1s; 
                        width: 100%; 
                        box-sizing: border-box;
                        box-shadow: 0 2px 4px 0 rgba(0, 34, 115, 0.5);
                    }
                    .bet-btn.active { 
                        background: rgba(136, 213, 255, 0.8); 
                    }
                    .bet-btn:active { 
                        transform: scale(0.97); 
                    }
                    .btn-tall { 
                        grid-row: span 2; 
                        padding: 0; 
                    }

                    .b-ratio { 
                        font-size: 11px; 
                        color: #c1e4ff; 
                        font-weight: bold; 
                        margin-bottom: 6px; 
                    }
                    .b-text-chan { 
                        font-size: 20px; 
                        font-weight: 900; 
                        color: #00d3ff; 
                        text-transform: uppercase; 
                    }
                    .b-text-le { 
                        font-size: 20px; 
                        font-weight: 900; 
                        color: #ffc107; 
                        text-transform: uppercase; 
                    }

                    /* DẤU CHẤM XÚC XẮC 3D */
                    .dice-row { 
                        display: flex; 
                        gap: 3px; 
                        align-items: center;
                    }
                    .d-dot { 
                        width: 13px; 
                        height: 13px; 
                        border-radius: 50%; 
                        border: 1px solid #bbb; 
                        box-shadow: inset -2px -2px 4px rgba(0,0,0,0.2), 1px 1px 2px rgba(0,0,0,0.1); 
                    }
                    .d-dot.w { background: #fff; }
                    .d-dot.r { background: #dc3545; border-color: #a71d2a; }

                    /* HUY HIỆU ÉP SANG GÓC TRÁI TRÊN CÙNG */
                    .bet-badge { 
                        position: absolute; 
                        top: 4px; 
                        left: 4px; 
                        width: 18px; 
                        height: 18px; 
                        border-radius: 50%; 
                        color: white; 
                        font-size: 11px; 
                        font-weight: bold; 
                        display: flex; 
                        align-items: center; 
                        justify-content: center; 
                        box-shadow: 0 2px 4px rgba(0,0,0,0.3); 
                        border: 1px solid rgba(255,255,255,0.4); 
                        z-index: 5; 
                    }
                    .bg-blue { background: #007bff; }
                    .bg-red { background: #dc3545; }
                    .bg-green { background: #28a745; }
                    .bg-yellow { background: #ffc107; color: #000; }

                    /* TEM STATUS LỊCH SỬ */
                    .badge-status {
                        padding: 3px 8px;
                        border-radius: 4px;
                        font-size: 11px;
                        color: #fff;
                        margin-left: 8px;
                        font-weight: bold;
                    }
                    .badge-status.win { background-color: #28a745; }
                    .badge-status.lose { background-color: #dc3545; }
                    .badge-status.pending { background-color: #ffc107; color: #000; }
                `}</style>
            </div>
        </>
    );
}

export default XD60s;